// Remise proposée sur les produits Ma gamme (décision du dirigeant du 31/10/2026) : constantes communes au serveur et à l'écran.
// « Les remises préconisées, par exemple 10 %, 15 %, 5 % ou 3 %, c'est un détail à préciser » : les taux sont donc un RÉGLAGE de la
// société (administrateur), ces valeurs-ci ne sont que le réglage par défaut. Rien n'est appliqué d'office : le dirigeant choisit.

/** Taux proposés par défaut (%), du plus petit au plus grand. */
export const TAUX_REMISE_DEFAUT = ['3', '5', '10', '15'] as const;
/** Bornes d'un taux proposé (réglage) et d'un taux saisi à la main au moment d'appliquer. */
export const TAUX_REMISE_MIN = 1;
export const TAUX_REMISE_MAX = 50;
/** Nombre de taux proposés au plus (réglage). */
export const TAUX_REMISE_NB_MAX = 8;
/** Seuil de marge minimale par défaut (% du total HT après remise, sur le coût total du devis) : 0 = jamais sous le coût. */
export const MARGE_MIN_DEFAUT = '0';
export const MARGE_MIN_MAX = 90;

export type AssietteRemise = 'devis' | 'ma_gamme';
export const LIBELLES_ASSIETTE: Record<AssietteRemise, string> = { ma_gamme: 'Lignes Ma gamme', devis: 'Tout le devis' };
/** « Remise de 5 % sur les lignes Ma gamme » : la même assiette, dans une phrase. */
export const ASSIETTE_PHRASE: Record<AssietteRemise, string> = { ma_gamme: 'sur les lignes Ma gamme', devis: 'sur tout le devis' };

/** Un taux tel que proposé au dirigeant : montants en chaînes décimales (au centime), pourcentages à 2 décimales. */
export interface TauxPropose {
  pct: string;
  remise: string | null;
  ht_net: string | null;
  marge: string | null;
  marge_pct: string | null;
  /** false = grisé à l'écran ET refusé par le serveur (vendrait sous le coût total ou sous le seuil de marge). */
  autorise: boolean;
  motif: string | null;
}

/** État du panneau « Remise proposée » (réponse de GET / POST / DELETE /api/devis/revisions/:rid/remise-proposee). */
export interface EtatRemiseProposee {
  revision_id: string;
  assiette: AssietteRemise;
  nb_lignes_gamme: number;
  base_gamme: string;
  ht_brut: string | null;
  cout_total: string | null;
  /** Marge sans remise (sur le coût total) ; null si non calculable. */
  marge_sans_remise: string | null;
  marge_sans_remise_pct: string | null;
  /** Raison pour laquelle AUCUN taux ne peut être appliqué (devis incomplet, coût inconnu…) ; null sinon. */
  non_calculable: string | null;
  marge_min_pct: string;
  remise_actuelle: { pct: string; assiette: AssietteRemise; montant: string | null } | null;
  taux: TauxPropose[];
}

export interface ReglagesRemiseProposee { taux: string[]; marge_min_pct: string; defaut: { taux: string[]; marge_min_pct: string } }

/** « 12.5 » → « 12,5 % » (sans zéros inutiles). */
export const pctFr = (p: string) => `${String(Number(p)).replace('.', ',')} %`;
